module.exports = __webpack_public_path__ + "static/media/1009029.642e1cbb.png";